<template>
  <v-layout row wrap>
    <v-flex lg12>
      <v-card flat class="futuristic-card mx-auto">
        <div class="card-header">
          <h3 class="accent-color">SYSTEM CHANGELOG</h3>
          <div class="title-decoration"></div>
        </div>
        <v-card-text class="py-0">
          <v-timeline dense>
            <v-slide-x-reverse-transition group hide-on-leave>
              <v-timeline-item v-for="item in allChangeLogs"
                               :key="item.public_id"
                               color="#1976D2"
                               small
                               fill-dot>
                <v-alert :value="true"
                         :icon="item.icon"
                         class="custom-alert"
                         dismissible>
                  <div class="alert-content">
                    <div class="version">{{ item.version }}</div>
                    <div class="description" v-html="item.description"></div>
                    <div class="meta">
                      Added on <b>{{ formated_date(item.created_at) }}</b> by <b>{{ item.action_by }}</b>
                    </div>
                  </div>
                </v-alert>
              </v-timeline-item>
            </v-slide-x-reverse-transition>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  const ICONS = {
    info: 'mdi-information',
    warning: 'mdi-alert',
    error: 'mdi-alert-circle',
    success: 'mdi-check-circle'
  }

  export default {
    name: 'Changelog',
    data: () => ({
      // items: [...] // removed for brevity, kept in original
    }),
    created() {
      this.$store.dispatch("get_change_log");
    },
    // computed: { allChangeLogs() { return this.$store.state.changeLogs; } } // example, adjust as needed
    // methods: { formated_date(date) { ... } } // if not globally available
  }
</script>

<style scoped>
  .futuristic-card {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  .card-header {
    background: linear-gradient(45deg, #e3f2fd, #f5f7fa);
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .accent-color {
    color: #0d47a1; /* deep blue */
    font-weight: 600;
    margin: 0;
  }

  .title-decoration {
    height: 4px;
    background: linear-gradient(90deg, #0d47a1, transparent);
    margin-bottom: 16px;
    width: 100px;
  }

  /* Custom alert styling – replaces the green background with a clean, readable look */
  .custom-alert {
    border-radius: 12px !important;
    background-color: #f0f7ff !important; /* very light blue */
    color: #1a1a1a !important; /* dark text for contrast */
    border-left: 5px solid #1976D2 !important; /* blue accent */
    box-shadow: 0 2px 4px rgba(0,0,0,0.04);
  }

    /* Override Vuetify's default icon color to match the accent */
    .custom-alert .v-icon {
      color: #1976D2 !important;
    }

  /* Text styling within the alert */
  .alert-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .version {
    font-weight: 700;
    font-size: 1.1rem;
    color: #0d47a1;
  }

  .description {
    font-size: 0.95rem;
    color: #333;
  }

  .meta {
    font-size: 0.85rem;
    color: #555;
    margin-top: 6px;
  }

  /* Keep the timeline dot color consistent */
  .v-timeline-item .v-timeline-item__dot {
    background-color: #1976D2 !important;
    border-color: #1976D2 !important;
  }

  /* Ensure any remaining green elements are removed */
  .v-timeline-item .v-timeline-item__inner-dot {
    background-color: #1976D2 !important;
  }
</style>
